exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cookie[data-v-91b338d6]{padding:18px 0;display:-ms-grid;display:grid;-ms-grid-columns:1fr;grid-template-columns:1fr}@media only screen and (min-width:40.063em){.cookie[data-v-91b338d6]{-ms-grid-columns:1fr 178px;grid-template-columns:1fr 178px;column-gap:12px}}.cookie_border[data-v-91b338d6]{padding:18px 0 12px;border-bottom:1px solid #eaeaea}.cookie__title[data-v-91b338d6]{margin-bottom:6px;font-size:14px}@media only screen and (min-width:40.063em){.cookie__title[data-v-91b338d6]{grid-area:1/1/2/3}}.cookie__text[data-v-91b338d6]{margin-bottom:12px;font-size:12px;line-height:1.25;color:#404040}@media only screen and (min-width:40.063em){.cookie__text[data-v-91b338d6]{margin-bottom:0;grid-area:2/1/3/2}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-91b338d6","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/usecookie/UseCookie.vue
// module id = d501854b1627cafef139
// module chunks = 7